import styled from 'styled-components'
import {
	media,
	Breakpoints,
	container,
	WrapperBlock,
	themeObject,
	textModels,
} from 'Pages/landings/newLandings/common/style'

export const Block = styled.div`
	${container}
	background: ${themeObject.colors.grey[900]};
`
export const Wrapper = styled(WrapperBlock)`
	display: flex;
	flex-direction: column;
	padding-top: 24px;
	padding-bottom: 32px;
	color: ${themeObject.colors.grey[500]};
	${textModels('notAdaptive', 'xs')}
	${media('padding-top: 32px; padding-bottom: 40px; flex-direction: row;', Breakpoints.lx)};
`
export const LeftText = styled.p`
	width: 100%;
	margin-bottom: 8px;
	${media('margin-bottom: 0px; margin-right: 32px;', Breakpoints.lx)};
`
export const RightText = styled.p`
	width: 100%;
`
